import * as THREE from 'three'
import CLOUDS from 'vanta/src/vanta.clouds.js'

CLOUDS({
  THREE,
  el: "#pilota-bg",
  mouseControls: false,
  touchControls: false,
  gyroControls: false,
  minHeight: window.innerHeight,
  minWidth: window.innerWidth
})

setTimeout(() => {
  document.getElementById('pilota-bg').style = null
})
